import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";

import type { IconSvg } from "@/types/IconSvg";

/**
 * Reduit une `IconDefinition` FontAwesome importee nommement (`faHome`,
 * `faPhone`...) a la forme rendue par `<Icon>`.
 *
 * Sur mesure pour les icones *fixes*, connues a la compilation. Ce module ne
 * charge volontairement aucun jeu d'icones, il peut donc etre importe depuis un
 * composant client — contrairement a `@/utilities/resolveIcons`, qui resout des
 * noms dynamiques et charge les jeux complets.
 *
 * IMPORTANT — importer l'icone par son sous-chemin, jamais depuis le barrel :
 *
 *     import { faHome } from '@fortawesome/free-solid-svg-icons/faHome'   // 618 o
 *     import { faHome } from '@fortawesome/free-solid-svg-icons'          // 1 Mo
 *
 * Turbopack n'elague pas `index.mjs` : un seul import nomme depuis le barrel y
 * embarque les 1 930 icones. Mesure sur staging le 2026-09-03, avant correction :
 * la page d'accueil telechargeait 295 Ko (930 Ko a parser) pour la seule icone
 * `faHome` de trois fils d'Ariane. Le sous-chemin est publie par la map
 * `exports` du paquet (`"./*": "./*.js"`), il n'y a donc rien a configurer.
 */
export const toIconSvg = (definition: IconDefinition): IconSvg => {
  const [width, height, , , path] = definition.icon;

  return {
    width,
    height,
    path: Array.isArray(path) ? path.join(" ") : path,
  };
};
